import { render, staticRenderFns } from "./YoutubeHeader.vue?vue&type=template&id=60ab9c6e&scoped=true&"
var script = {}
import style0 from "./YoutubeHeader.vue?vue&type=style&index=0&id=60ab9c6e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60ab9c6e",
  null
  
)

export default component.exports